import React, { useEffect, useRef } from 'react';

// This hook is used to run an effect only on component updates, not on the initial mount.
const useDidMountEffect = (
  effect: React.EffectCallback,
  deps?: React.DependencyList,
) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) effect();
    else didMount.current = true;
  }, deps);
};

export default useDidMountEffect;
